// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3Bqx_ path[fill]{fill:#f4c708}._1Cp5d path[fill]{fill:#dcdddd}._11xgY{stroke:#9fa0a0}._1LQhR{stroke:#f4c708}._2CPj4 path[fill]{fill:#595757}._1AeVB path[fill]{fill:#231815}.xm3Ue{-webkit-transition:all .3s cubic-bezier(.645,.045,.355,1);-o-transition:all .3s cubic-bezier(.645,.045,.355,1);transition:all .3s cubic-bezier(.645,.045,.355,1)}._3BBSe{position:relative;display:-ms-flexbox;display:flex;-ms-flex-direction:row-reverse;flex-direction:row-reverse;grid-gap:28px;gap:28px;grid-gap:1.75rem;gap:1.75rem}@media(max-width:767px){._3BBSe{grid-gap:.5rem;gap:.5rem}}._3BBSe.lKkuL{grid-gap:8px;gap:8px;grid-gap:.5rem;gap:.5rem}._3BBSe.lKkuL .xm3Ue,._3BBSe:hover .xm3Ue{stroke-width:0!important}._3BBSe.lKkuL .xm3Ue path[fill],._3BBSe:hover .xm3Ue path[fill]{fill:#dcdddd}._2B0ME{cursor:pointer}._3BBSe:hover ._2B0ME:hover .xm3Ue,._3BBSe:hover ._2B0ME:hover~._2B0ME .xm3Ue,._3BBSe:not(:hover) ._2B0ME._3eQNW .xm3Ue,._3BBSe:not(:hover) ._2B0ME._3eQNW~._2B0ME .xm3Ue{stroke-width:0!important}._3BBSe:hover ._2B0ME:hover .xm3Ue path[fill],._3BBSe:hover ._2B0ME:hover~._2B0ME .xm3Ue path[fill],._3BBSe:not(:hover) ._2B0ME._3eQNW .xm3Ue path[fill],._3BBSe:not(:hover) ._2B0ME._3eQNW~._2B0ME .xm3Ue path[fill]{fill:#f4c708}._1sR13{position:absolute;left:0;display:none;width:100%;margin-top:.5rem}@media(min-width:768px){._1sR13{text-align:center}}._3BBSe:not(:hover) ._2B0ME._3eQNW ._1sR13,._2B0ME:hover ._1sR13{display:block}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"filled": "_3Bqx_",
	"unfilled": "_1Cp5d",
	"hollow": "_11xgY",
	"brightHollow": "_1LQhR",
	"grayFilled": "_2CPj4",
	"darkFilled": "_1AeVB",
	"star": "xm3Ue",
	"root": "_3BBSe",
	"scored": "lKkuL",
	"wrapper": "_2B0ME",
	"selected": "_3eQNW",
	"comment": "_1sR13"
};
module.exports = exports;
